import psHttp from '@patsnap/common-ps-http';
import { coreBasicApiUrlPrefix } from 'library-@/config/constants';

export default async function getInit() {
    try {
        const { data } = await psHttp({
            url: `${coreBasicApiUrlPrefix}/analytics/commonConfig`,
            method: 'GET',
            cache: true
        });
        return data || {};
    } catch (err) {
        throw err;
    }
}
